import { cn } from '@/lib/utils'
import { SoloViewerToken } from '@utils/common'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'

type TinyGalleryProps = {
  tokens: SoloViewerToken[]
  currentTokenIndex: number
  onTokenClick: (newIndex: number) => void
  className?: string
}

export function TinyGallery({
  tokens,
  currentTokenIndex,
  onTokenClick,
  className
}: TinyGalleryProps): React.ReactElement {
  return (
    <div key="tiny-gallery" className={cn(`gap-x-2xs relative flex h-full`, className)}>
      {tokens.map((token, index) => (
        <div
          key={token.media_url ?? token.token_id}
          className={cn(
            `h-lg w-lg relative aspect-square cursor-pointer opacity-60 transition-opacity duration-100 hover:opacity-100`,
            {
              'outline-primary-8 opacity-100 shadow-md outline outline-1': currentTokenIndex === index
            }
          )}
          onClick={() => onTokenClick(index)}
        >
          <ImageWithCustomLoader
            src={token.media_url ?? ''}
            alt={token.token_id?.toString() ?? ''}
            priority
            fill
            style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }}
            sizes="5vw"
            blurHash={token.image?.metadata?.blurhash}
          />
        </div>
      ))}
    </div>
  )
}
